import React from "react";

import { useTranslations } from "@/shared/hooks";

interface LanguageSwitcherProps {
  showName?: boolean;
  /** dark = fond sombre (header admin, landing) ; light = pages claires */
  variant?: "dark" | "light";
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  showName = true,
  variant = "dark",
}) => {
  const { i18n, changeLanguage, getLanguages } = useTranslations();
  const languages = getLanguages();

  const handleLanguageChange = async (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const newLang = event.target.value;
    await changeLanguage(newLang);
  };

  const isLight = variant === "light";

  return (
    <div className="relative">
      <select
        value={i18n.language}
        onChange={handleLanguageChange}
        className={
          isLight
            ? "appearance-none bg-surface border border-border text-foreground rounded-md pl-3 pr-8 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-light focus:border-primary cursor-pointer hover:bg-background-secondary transition-colors"
            : "appearance-none bg-slate-800 border border-slate-600 text-white rounded-lg pl-4 pr-10 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent cursor-pointer hover:bg-slate-700 transition-colors shadow-lg"
        }
      >
        {languages.map((lang) => (
          <option
            key={lang.code}
            value={lang.code}
            className={isLight ? "bg-surface text-foreground" : "bg-slate-800 text-white"}
          >
            {showName ? `${lang.flag} ${lang.name}` : lang.flag}
          </option>
        ))}
      </select>
      <div
        className={`pointer-events-none absolute inset-y-0 right-0 flex items-center ${isLight ? "px-2 text-foreground-secondary" : "px-3 text-slate-400"}`}
      >
        <svg
          className="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
  );
};

export { LanguageSwitcher };
export default LanguageSwitcher;
